import combineReducers from '../../../utilities/combineReducers';
import entities from './entities';
import ui from './ui';

export default combineReducers({
  entities,
  ui,
});



// WEBPACK FOOTER //
// ./src/modules/games/reducers/index.js